import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import { scrollEffectStyleVertical } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ModalStyled = styled.div<{ $show: boolean }>`
  position: absolute;
  z-index: 3;
  top: 6rem;
  right: 0;
  width: 40rem;
  background-color: ${colors.neutral.white};
  border-radius: 0.6rem;
  box-shadow: 0 0.4rem 0.8rem rgb(0 0 0 / 14%);
  max-height: 55rem;
  display: ${({ $show }): string => ($show ? 'block' : 'none')};
  color: ${colors.neutral[900]};
`;

export const ModalHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 2.4rem 1.5rem 2rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const ApplyClassesTextStyled = styled.p`
  ${typography.regular[16]};
  text-align: center;
  margin: 0;
`;

export const EmployeesCountStyled = styled.b`
  color: ${colors.green[600]};
`;

export const ClassButtonStyled = styled(Button)`
  padding: 0;
`;

export const ScrollAreaStyled = styled.div`
  ${scrollEffectStyleVertical()};
  overflow-y: auto;
  max-height: 40rem;
`;

export const ModalFooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding: 2.4rem;
  border-top: 0.1rem solid ${colors.neutral[300]};
`;

export const FooterButtonStyled = styled(Button)`
  padding: 0 5rem;
`;

export const ApplyFooterButtonStyled = styled(FooterButtonStyled)`
  border: none;
`;
